import PlannedTimeRepository from "../PlannedTimeRepository.js";
import PlannedTime from "../PlannedTime.js";

class ClickUpPlannedTimeRepository extends PlannedTimeRepository {

    /**
     * @private {ClickUpClient}
     */
    _client;

    /**
     * @private {CustomerRepository}
     */
    _customerRepo;

    _workSpaceId = "";

    _customTaskType = '1002';

    /**
     * @param {ClickUpClient} client
     * @param {CustomerRepository} customerRepository
     * @param {string} workSpaceId
     */
    constructor(client, customerRepository, workSpaceId) {
        super();
        this._client = client;
        this._customerRepo = customerRepository;
        this._workSpaceId = workSpaceId;

    }

    async getDuring(start, end) {
        let customers = await this._customerRepo.all();
        let findCustomerByFolderName = (folderName) => {
            for (let customer of customers) {
                if (customer.folderName === folderName) {
                    return customer;
                }
            }
            return null;
        };
        let tasks = await this._client.findTasks(this._workSpaceId, {
            due_date_gt: start.getTime(),
            due_date_lt: end.getTime(),
            order_by: 'due_date',
            reverse: 'true',
            'custom_items[]': this._customTaskType
        });
        let plannedTimes = [];

        for (let task of tasks) {
            if (!task.startDate || !task.dueDate) {
                console.warn('Skipping task to PlannedTime conversion because of missing dates:', task);
                continue;
            }

            let plannedTime = new PlannedTime({
                id: task.id,
                customId: task.customId,
                title: task.name,
                start: task.startDate,
                end: task.dueDate
            });

            if (task.parent && task.parent.parent && task.parent.parent.name) {
                plannedTime.customer = findCustomerByFolderName(task.parent.parent.name);
            }

            plannedTimes.push(plannedTime);
        }

        return Promise.resolve(plannedTimes);
    }
}

export default ClickUpPlannedTimeRepository;